/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Suspense, useState } from "react";
import { Button } from "@mui/material";
import HistoryIcon from "@mui/icons-material/HistoryOutlined";
import { SuspenseWithFallBack } from "../../ui-components/SuspenseWithFallBack";
import { ServicerHistoryPopUp } from "./ServicerHistoryPopUp";

export const ServicerHistoryWrapper = (props: any) => {
  const { historyObject } = props;
  const [showHistory, setShowHistory] = useState(false);
  return (
    <SuspenseWithFallBack>
      {showHistory && (
        <Suspense fallback={<span>Loading...</span>}>
          <ServicerHistoryPopUp
            onClose={setShowHistory}
            originatorName={historyObject.originatorName}
          />
        </Suspense>
      )}
      <Button
        startIcon={<HistoryIcon fontSize="large" />}
        onClick={() => {
          setShowHistory(true);
        }}
      />
    </SuspenseWithFallBack>
  );
  // return <ServicerHistoryPopUp historyObject={historyObject} />;
};
